import { Button, Box, Typography } from '@mui/material'
import React from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

const Mode4 = (props) => {
 
    const { user: currentUser } = useSelector((state) => state.auth);
    const navigate = useNavigate()
    const DisplayModeFrame = props.DisplayModeMasterFrame.DisplayModeSQL[0]
    const CurrentAssessment = DisplayModeFrame.SurveyDisplayMode4Frame.CurrentAssessment && DisplayModeFrame.SurveyDisplayMode4Frame.CurrentAssessment[0] ? DisplayModeFrame.SurveyDisplayMode4Frame.CurrentAssessment[0]: {ProgressText:""}

    const handleContinue = (guid) => {
        
        fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + props.settings.SessionVariableValues["PERSON GUID"] +'/ASSMT%20PRODUCT%20GUID/' + DisplayModeFrame.SurveyDisplayMode4Frame.AssessmentProductGuid + '/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }})
            .then(response=>response.json())
            .then(response=>{
                fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + currentUser.AuthToken + '/RESPONSE%20GUID/' + guid+'/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }})
                    .then(response=>response.json())
                    .then(response=>{
                        navigate({pathname: '/hra', search: createSearchParams({vi: 'B87190C3-B9C8-41D7-A1C8-10E07FBA0D3E', assmtguid: guid }).toString()})
                    })
            })
                
                
    }
    return (
        <Box sx={{textAlign: "center"}}>
            <Typography paragraph>{CurrentAssessment.ProgressText}</Typography>
            <Progress theme={{
                                            active: {
                                              color: 'green'
                                            },
                                            default: {
                                              color: 'red'
                                            }
                                          }} 
                                    status='active' percent={DisplayModeFrame.SurveyDisplayMode4Frame.HRAProgressPCTValue} />
                              
            <Typography paragraph>{DisplayModeFrame.SurveyDisplayMode4Frame.HRAProgressPCTValue} %</Typography>
            <Button variant="contained" onClick={()=>handleContinue(DisplayModeFrame.SurveyDisplayMode4Frame.ContinueAssessmentFrame.ContinueAssessmentGUID)}>
                {DisplayModeFrame.SurveyDisplayMode4Frame.ContinueAssessmentFrame.ContinueAssessmentButton}</Button>
        </Box>
    )
}

export default Mode4